// apps/web/src/components/offers/OffersManager.tsx
// Offer + negotiation management.

import { ManagerPage } from '../platform/ManagerPage.js';
import type { Offer } from '../../types/platform.js';

export function OffersManager() {
  return (
    <ManagerPage
      title="Offers"
      listPath="/api/v1/offers"
      listKey="offers"
      createLabel="New Offer"
      className="offers-manager"
      renderItem={(raw) => {
        const o = raw as Offer;
        return (
          <div className="manager-card" key={o.id}>
            <h3>Offer</h3>
            <p className="status-badge">{o.status}</p>
            <p>Campaign {o.campaignId.slice(0, 8)} · {o.proposedAmount ?? 0} {o.currency ?? 'USD'}</p>
            <div className="actions">
              <button className="btn btn-secondary">Negotiate</button>
              <button className="btn btn-primary">Accept</button>
              <button className="btn btn-danger">Decline</button>
            </div>
          </div>
        );
      }}
    />
  );
}